import {
  ApolloClient,
  ApolloProvider,
  InMemoryCache,
  split,
} from '@apollo/client';
import { createUploadLink } from 'apollo-upload-client';
import { ChakraProvider } from '@chakra-ui/react';
import theme from './theme/theme';
import React, { useEffect, useState } from 'react';
import { BrowserRouter, Redirect, Route, useHistory } from 'react-router-dom';
import AuthLayout from './layouts/auth';
import AdminLayout from './layouts/admin';
import { createClient } from 'graphql-ws';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { getMainDefinition } from '@apollo/client/utilities';

const wsLink = new GraphQLWsLink(
  createClient({
    // url: 'ws://localhost:3026/graphql',
    url: process.env.REACT_APP_WS_URI,
    connectionParams: {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`, // Replace with how you handle auth token
      },
    },
  })
);

const uploadLink: any = createUploadLink({
  // uri: 'http://localhost:3026/graphql',
  uri: process.env.REACT_APP_URI,
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`, // Replace with how you handle auth token
  },
});

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  wsLink,
  uploadLink
);

export const client = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache(),
});
export const App = () => {
  const history = useHistory();
  const [isAuthenticate, setIsAuthenticate] = useState(false);
  useEffect(() => {
    const token = localStorage.getItem('token');
    console.log(token);
    if (token) {
      setIsAuthenticate(true);
    }
  }, [history]);
  return (
    <ApolloProvider client={client}>
      <ChakraProvider theme={theme}>
        <React.StrictMode>
          <BrowserRouter>
            <Route
              path={`${process.env.REACT_APP_URL_PREFIX || ''}/login`}
              component={AuthLayout}
            />
            {isAuthenticate && <Route path={`/`} component={AdminLayout} />}
            {!isAuthenticate && (
              <Redirect
                to={`${process.env.REACT_APP_URL_PREFIX || ''}/login`}
              />
            )}
          </BrowserRouter>
        </React.StrictMode>
      </ChakraProvider>
    </ApolloProvider>
  );
};
